import $ from 'jquery'
import validate from 'jquery-validation'

export function handleFormSubmit(props) {
    const {intl} = props;
    $("#application_form").keypress((e) => {
        if (e.which === 13) {
            e.preventDefault();
        }
    });

    $("#application_form").validate({
        invalidHandler: function (form, validator) {
            let errors = validator.numberOfInvalids();
            if (errors) {
                validator.errorList.forEach(function (error) {
                    error.element.focus();
                });
            }
        },
        errorPlacement: function (error, element) {
            if (error.text() != "") {
                $(element).parents(".AnswerField").find(".AnswerField-errorMessage").html(intl.formatMessage({id: error.text()})).show();
            } else {
                $(element).parents(".AnswerField").find(".AnswerField-errorMessage").html("").hide();
            }
        },
        success: function (element) {
            $(element).parents(".AnswerField").find(".AnswerField-errorMessage").html("").hide();
        },
        highlight: function (element) {
            $(element).parents(".AnswerField").addClass("error");
        },
        unhighlight: function (element) {
            $(element).parents(".AnswerField").removeClass("error");
        }
    });

    $.validator.addMethod("selectone", function (value) {
        if (value != '' && value != undefined) {
            return true;
        }
        return false;
    });

    $.validator.addMethod("date", function (value, element) {
        if (value == '') {
            return true;
        }
        var yearExp = new RegExp(/^\d{4}$/);
        if (!yearExp.test(value) || parseInt(value) < 1900) {
            return false;
        }
        var regExp = new RegExp(/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/)
        var month = $('[name="' + $(element).attr("data-dependent-attribute-month") + '"]').val();
        var day = $('[name="' + $(element).attr("data-dependent-attribute-day") + '"]').val();
        var date = day + "/" + month + "/" + value

        var startYear = $(element).attr("data-dependent-attribute-start-year");
        var startDate = new Date()
        if (startYear == undefined || startYear == "") {
            startDate = new Date(1900, 1, 1)
        } else {
            startDate = new Date(parseInt(startYear), 1, 1)
        }
        var endYear = $(element).attr("data-dependent-attribute-end-year");
        var endDate = new Date()
        if (endYear == undefined || endYear == "") {
            endDate = new Date()
        } else {
            endDate = new Date(parseInt(endYear), 12, 31)
        }
        var months = {"Jan": 0,"Feb": 1,"Mar": 2,"Apr": 3,"May": 4,"Jun": 5,"Jul": 6,"Aug": 7,"Sep": 8,"Oct": 9,"Nov": 10,"Dec": 11};
        var actualDate = new Date(parseInt(value), parseInt(months[month]), parseInt(day));
        return regExp.test(date) ? (actualDate >= startDate) : false;
    });

    $.validator.addMethod("futuredateallowed", function (value, element) {
        if (value == '') {
            return true;
        }
        var yearExp = new RegExp(/^\d{4}$/);
        if (!yearExp.test(value) || parseInt(value) < 1900) {
            return false;
        }
        var regExp = new RegExp(/^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]|(?:Jan|Mar|May|Jul|Aug|Oct|Dec)))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2]|(?:Jan|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec))\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)(?:0?2|(?:Feb))\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9]|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep))|(?:1[0-2]|(?:Oct|Nov|Dec)))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/)
        var month = $('[name="' + $(element).attr("data-dependent-attribute-month") + '"]').val();
        var day = $('[name="' + $(element).attr("data-dependent-attribute-day") + '"]').val();
        var date = day + "/" + month + "/" + value

        var todayDate = new Date()

        var months = {"Jan": 0,"Feb": 1,"Mar": 2,"Apr": 3,"May": 4,"Jun": 5,"Jul": 6,"Aug": 7,"Sep": 8,"Oct": 9,"Nov": 10,"Dec": 11};
        var actualDate = new Date(parseInt(value), parseInt(months[month]), parseInt(day));
        return regExp.test(date) ? (todayDate > actualDate) : false;
    });

    $.validator.addMethod("liberal", function (value) {
        if (value == '') {
            return true;
        }

        var regExpForWhiteSpace = new RegExp(/^[\s]*$/);
        if (!regExpForWhiteSpace.test(value)) {
            var regExp = new RegExp(/^[a-zA-Z\s]+$/);
            return regExp.test(value);
        } else {
            return false;
        }
    });
}

export function submitFormData() {
    if ($('#application_form').valid()) {
        return true
    }
    return false
}
